export const strings = {
    CURRENT_PAGE: 'current_page',
    TRY_TIMES: 'try_times',
    ANSWERS: 'answers',
    SCORE: 'score',
    RESULTS: 'results',
};

export const routeNames = {
    START: '/start',
    RESULT_DETAIL: '/result_detail',
    RESULT_LIST: '/result'
};

export const questionTypes = {
    MULTIPLE_CHOICE: 'MC',
    COMBO_BOX: 'CB',
    TEXT_INPUT: 'TI',
    GROUP_QUESTION: 'GR',
    NO_ANSWERS: 'NA'
};

export const testTypes = {
    KIEM_TRA: 1,
    ON_TAP: 2,
    THI_CU: 3,
    TRAC_NGHIEM_VUI: 4,
    BINH_CHON: 5,
    KHAO_SAT: 6,
    TRAC_NGHIEM_SO_SANH: 7,
    TRAC_NGHIEM_THEO_KICH_BAN: 8,
    TRAC_NGHIEM_TINH_DIEM: 9
};

export const lessonTypes = {
    KT_CUOI_KY: 1,
    ON_TAP: 2,
    KT_GIUA_KY: 3
};

export const testStatusNames = {
    TEST_STARTER_STATUS: "starterStatus",
    TEST_IN_PROGRESS_STATUS: "inProgressStatus"
};